<template>
    <div class="m-0">
            <button type="button" class="btn btn-dark custom-confirm" 
            v-if="!compartmentsShow" 
            @click="toogle">Confirm</button>

        
        
        <b-card no-body class="m-auto" v-if="compartmentsShow">
            <b-tabs pills card :align="'center'">
                <b-tab :title="$t('Compartments')">
                    <b-card-text>
                        <b-list-group class="mt-3">
                            <b-form-input class="mb-3" type="text" v-model="compartmentsSearch" :placeholder="$t('SearchGoods')"/>
                            <b-form-group>
                                <b-form-checkbox-group id="checkbox-group-3" name="flavour-3">

                                    <CompartmentsList 
                                        :shipmentId="shipmentId" 
                                        :compartments="filteredCompartmentsList" 
                                        @submitCompartments="submitCompartments">
                                    </CompartmentsList>

                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-list-group>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>
        
        <b-modal id="sidnature_modal" v-model="signatureModalShow" hide-footer>

            <template v-slot:modal-title>
                {{$t('OrderConfirmation')}}
            </template>

            <Loading class="mt-3" v-if="isRequestSending" />

            <b-form class="col" @reset="onReset" v-if="!isRequestSending">

                <b-form-group>
                    <label for="input-name">{{$t('RecipientName')}}:</label>
                    <b-form-input id="input-name"
                                  v-model="recipientName"
                                  required
                                  :placeholder="$t('RecipientName')"></b-form-input>
                </b-form-group>

                <b-form-group>

                    <label for="signature">{{$t('RecipientSignature')}}:</label>
                    <VueSignaturePad id="signature" v-if="renderSignature" class="m-0" width="100%" height="400px" ref="signaturePad" />

                </b-form-group>


                <footer class="modal-footer">
                    <b-alert v-model="showAlert" variant="danger" dismissible>
                        {{this.validationMessage}}
                    </b-alert>
                    <b-button type="button" @click="undo" variant="secondary">{{$t('Undo')}}</b-button>
                    <b-button type="reset" variant="danger">{{$t('Reset')}}</b-button>
                    <b-button type="button" @click="submit" variant="success">{{$t('Send')}}</b-button>
                </footer>
            </b-form>

        </b-modal>
    </div>
</template>

<style>
    .custom-confirm {
    position: fixed;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px; 
    height: 40px; 
    z-index: 999;
}
</style>

<script>
    import { mapGetters } from "vuex";
    import { CONFIRMORDER_REQUEST, ORDERSTATUS_CLEAR, SIGNATURESTATUS_CLEAR } from "actions/confirmOrder";
    import { POSTCOMPARTMENTS_REQUEST, POSTCOMPARTMENTS_CLEAR } from "actions/compartments";
    import { COMPARTMENTS_REQUEST } from "actions/compartments"
    import CompartmentsList from "components/CompartmentsList";

    export default {
        name: "ConfirmOrderModal",
        props: ['orderDetails', 'returnGoodsList', 'extraList', 'tripLineId', 'shipmentId'],
        components: {
            CompartmentsList
        },
        data() {
            return {
                recipientName: "",
                renderSignature: false,
                signatureModalShow: false,
                compartmentsShow: false,
                showAlert: false,
                validationMessage: "",
                data: null,
                compartmentsSearch: ""
            };
        },
        watch: {
            signatureModalShow: function (val) {
                setTimeout(() => this.renderSignature = val, 100);
            },
            ReqSendingStatus: function (val) {
                const [orderReqStatus, signatureReqStatus] = val.split('|');

                if (orderReqStatus === "success" && signatureReqStatus === "success") {
                    this.$root.$children[0].$refs.requestToats.makeToast('primary', this.$t('ConfirOrderSucTitle'), this.$t('ConfirOrderSucBody'));
                    this.$store.commit(ORDERSTATUS_CLEAR);
                    this.$store.commit(SIGNATURESTATUS_CLEAR);
                    this.$router.push("/");
                }
                if (orderReqStatus === "error" || signatureReqStatus === "error") {
                    this.$root.$children[0].$refs.requestToats.makeToast('danger', this.$t('ConfirOrderErrTitle'), this.$t('ConfirOrderErrBody'));
                    this.$store.commit(ORDERSTATUS_CLEAR);
                    this.$store.commit(SIGNATURESTATUS_CLEAR);
                    this.$router.push("/");
                }
            }
        },
        mounted() {
            this.$store.dispatch(COMPARTMENTS_REQUEST);
        },
        computed: {
            ...mapGetters(["isRequestSending", "getConfirmOrderStatus", "getSignatureStatus", "getCompartments", "getCompartmentsStatus"]),
            ReqSendingStatus() {
                return `${this.getConfirmOrderStatus}|${this.getSignatureStatus}`;
            },
            filteredCompartmentsList() {
                return this.getCompartments.filter(f => f.Name.toLowerCase().includes(this.compartmentsSearch.toLowerCase()));
            }
        },
        created: function () {
            this.$bvModal.show('sidnature_modal');
        },
        methods: {
            toogle(){
                this.compartmentsShow = !this.compartmentsShow;
                this.$emit('status-changed', this.compartmentsShow);
            },
            undo() {
                this.$refs.signaturePad.undoSignature();
                this.signatureModalShow = false;
            },
            save() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                this.data = data;
            },
            getCompartmentsToApi() {
                let compartments = this.getCompartments.map(item => ({shipmentId: this.shipmentId, quantitydel: item.delivered, quantityload: item.loaded, product: item.Product}))
                compartments = compartments.filter(item => item.quantitydel > 0 || item.quantityload > 0)
                return compartments;
            },
            submitCompartmentsToApi(signature) {
                let compartments = this.getCompartments.map(item => ({shipmentId: this.shipmentId, quantitydel: item.delivered, quantityload: item.loaded, product: item.Product}))
                compartments = compartments.filter(item => item.quantitydel > 0 || item.quantityload > 0)
                if(data.length < 1) {
                    this.$emit('submitCompartments', true);
                    return;
                }
                let req = {
                    shipmentId: this.shipmentId,
                    compartments,
                    signature
                }
                this.$store.dispatch(POSTCOMPARTMENTS_REQUEST, req).then((result) => {
                    this.$store.commit(POSTCOMPARTMENTS_CLEAR);
                    this.$emit('submitCompartments', result === "success");
                });

            },
            submit() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

                if (this.isOnline)
                    if (!this.$refs.signaturePad.isEmpty() && this.recipientName.length >= 2) {
                        this.showAlert = false;
                        const compartments = this.getCompartmentsToApi();

                        this.$store.dispatch(CONFIRMORDER_REQUEST, {
                            order: this.orderDetails,
                            returnGoodsList: this.returnGoodsList,
                            extraList: this.extraList,
                            tripLineId: this.tripLineId,
                            shipmentId: this.shipmentId,
                            compartments,
                            signature: {
                                shipmentId: this.shipmentId,
                                name: this.recipientName,
                                signature: data.replace('data:image/png;base64,', '')
                            }
                        });
                    }
                    else {
                        this.showAlert = true;
                        if(this.$refs.signaturePad.isEmpty() && this.recipientName.length < 2)
                            this.validationMessage = this.$t('NotValidNameAndSignature');
                        else if (!this.$refs.signaturePad.isEmpty())
                            this.validationMessage = this.$t('NotValidName');
                        else if(this.recipientName.length >= 2)
                            this.validationMessage = this.$t('NotValidSignature');
                    }
                else
                    this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
            },
            onReset() {
                this.recipientName = '';
                this.$refs.signaturePad.clearSignature();
            },
            submitCompartments(isSubmited) {
               
                if (isSubmited) {
                    this.signatureModalShow = true;
                    return;
                }else{
                    this.toogle();
                }
            },
        }
    };
</script>
